import { firstTruthy } from '../utils/util';
import { BrowserSupportService } from './browser-support.service';
import { Injectable, inject } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { getPunchOutErrorCode, getStorefrontErrorCode } from '@app/shared/reducers/storefront.reducer';
import { getIsMaintenanceMode } from '@app/user/reducers/auth.reducer';
import { combineLatest, Observable, of, race } from 'rxjs';
import { map } from 'rxjs/operators';

export enum FaultCode {
	NotFound = 1,
	UnsupportedBrowser,
	PunchOutError,
	Maintenance,
}

@Injectable({
	providedIn: 'root',
})
export class FaultCodeService {
	private readonly store = inject<Store<RootReducer.State>>(Store);
	private readonly browserSupportService = inject(BrowserSupportService);

	getFaultCode$(): Observable<FaultCode> {
		if (!this.browserSupportService.isUserBrowserSupported()) {
			return of(FaultCode.UnsupportedBrowser);
		}

		const maintenance$ = combineLatest([
			this.store.select(getIsMaintenanceMode).pipe(firstTruthy),
			this.store.select(getStorefrontErrorCode).pipe(map(Number)),
		]).pipe<FaultCode>(
			map(([, storeErrorCode]) => {
				return storeErrorCode === 404 ? FaultCode.NotFound : FaultCode.Maintenance;
			}),
		);

		const punchOut$ = this.store.select(getPunchOutErrorCode).pipe(
			firstTruthy,
			map(() => FaultCode.PunchOutError),
		);

		return race(maintenance$, punchOut$);
	}
}
